/**
 * Prefetch entry registry.
 *
 * Maps page path patterns to prefetch entries. Used by the prefetch entry point
 * to determine which caches to seed based on the current route.
 */

import { dashboardEntry } from './entries/dashboard';
import type { PrefetchEntry } from './types';

/**
 * Registry mapping page paths to prefetch entries.
 *
 * Keys are the page path after /<orgId>/ (e.g., 'dashboard', 'crm/contacts', or '' for index).
 */
const registry: Record<string, PrefetchEntry> = {
  '': dashboardEntry, // Index route (/<orgId>/)
  dashboard: dashboardEntry, // Dashboard route (/<orgId>/dashboard)
};

/**
 * Get the prefetch entry for a given page path.
 *
 * @param pagePath - Page path extracted from parseOrgRoute (e.g., 'dashboard', 'crm/contacts', '')
 * @returns Prefetch entry or undefined if no entry registered
 */
export function getEntryForPath(pagePath: string): PrefetchEntry | undefined {
  return registry[pagePath];
}
